import { Fragment, useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft,  Award, TrendingUp, TrendingDown, Calendar, MinusCircle, ArrowDown, ArrowUp, Star, PlusCircle } from "react-feather";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Button,
    Badge,
} from "reactstrap";
import DataTable from "react-data-table-component";
import axios from "axios";
import { toast } from "react-toastify";
import moment from "moment";
import { baseURL } from "../../../../Services/api/baseURL";
import Loader from "../../../Loader/Loader";
import PointsModal from "./PointsModal";
import useRbac from "../../../../Hooks/useRbac";

const LoyaltyHistory = () => {
    const { can } = useRbac();
    const { customerId: userId } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(true);
    const [userData, setUserData] = useState(null);
    const [historyData, setHistoryData] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [isAdd, setIsAdd] = useState(false);
    const navigationData = location.state;

    const fetchUserHistory = async () => {
        console.log("UserId from params:", userId);

        if (!userId || userId === 'undefined') {
            toast.error("Invalid user ID!");
            navigate('/loyalty');
            return;
        }

        setIsLoading(true);
        try {
            const token = JSON.parse(localStorage.getItem("token"));
            const response = await axios.get(
                `${baseURL}/api/admin/loyalty/history/${userId}`,
                {
                    headers: {
                        Authorization: `${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (response.status === 200) {
                const data = response.data.data;

                
                setUserData({
                    user: data.user,
                    balance: data.balance,
                    totalEarned: data.totalEarned,
                    totalRedeemed: data.totalRedeemed,
                    totalDeducted: data.totalDeducted
                });
                setHistoryData(data.pointsHistory || []);
            }
        } catch (error) {
            console.error("API Error:", error);
            console.error("Full error response:", error.response);

            if (error.response?.status === 404) {
                toast.error("User loyalty history not found!");
            } else 
              if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Failed to fetch user history!");
            }
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchUserHistory();
    }, [userId]);

    // Navigation handlers
    const handleBack = () => {
        navigate('/loyalty');
    };



    const historyColumns = [
        {
            name: 'Date',
            selector: row => row.date,
            sortable: true,
            width: '200px',
            cell: (row) => (
                <div className="d-flex align-items-center">
                    <Calendar size={14} className="me-2 text-muted" />
                    <span>{moment(row.date).format('DD MMM YYYY')}</span>
                </div>
            )
        },
        {
            name: 'Type',
            selector: row => row.type,
            sortable: true,
            width: '200px',
            cell: (row) => {
                let color = 'secondary';
                let label = row.type;
                let icon = null;

                if (row.type === 'earn') {
                    color = 'success';
                    label = 'Earned';
                    icon = <TrendingUp size={12} className="me-1" />;
                } else if (row.type === 'redeem') {
                    color = 'danger';
                    label = 'Redeemed';
                    icon = <TrendingDown size={12} className="me-1" />;
                } else if (row.type === 'deduct') {
                    color = 'warning';
                    label = 'Deducted';
                    icon = <MinusCircle size={12} className="me-1" />;
                }

                return (
                    <Badge
                        color={color}
                        className="d-flex align-items-center"
                        style={{ width: 'fit-content' }}
                    >
                        {icon} {label}
                    </Badge>
                );
            }
        },
        {
            name: 'Points',
            selector: row => row.points,
            sortable: true,
            width: '200px',
            cell: (row) => (
                <span className={`fw-bold ${row.type === 'earn' ? 'text-success' : 'text-danger'}`}>
                    {row.type === 'earn' ? '+' : '-'}{row.points}
                </span>
            )
        },
{
  name: <div style={{ textAlign: "left", width: "100%", paddingLeft: "12px" }}>Reason</div>,
  cell: (row) => (
    <div style={{ textAlign: "left", width: "100%", paddingLeft: "12px" }}>
      {row.reason}
    </div>
  ),
  grow: 3,
}

    ];

    if (isLoading) {
        return (
            <Container fluid style={{ paddingTop: '30px' }}>
                <Loader />
            </Container>
        );
    }

    if (!userData) {
        return (
            <Container fluid style={{ paddingTop: '30px' }}>
                <Card>
                    <CardBody className="text-center py-5">
                        <h5>User not found</h5>
                        <Button color="primary" onClick={handleBack}>
                            <ArrowLeft size={16} className="me-2" />
                            Back to Loyalty Program
                        </Button>
                    </CardBody>
                </Card>
            </Container>
        );
    }

    return (
        <Fragment>
            <Container fluid >
            {/* User Info Cards */}
         <Row className="mb-3 g-3">
  {/* Balance */}
  <Col lg={2} md={6}>
    <Card className="h-100 shadow-sm border-0 rounded-3">
      <CardBody className="d-flex align-items-center p-3">
        <div
          className="d-flex align-items-center justify-content-center bg-light-success rounded-3 me-3"
          style={{ width: 40, height: 40 }}
        >
          <Award size={20} className="text-success" />
        </div>
        <div>
          <h5 className="mb-0 fw-bold text-success">{userData.balance}</h5>
          <small className="text-muted">Current Balance</small>
        </div>
      </CardBody>
    </Card>
  </Col>

  {/* Total Earned */}
  <Col lg={2} md={6}>
    <Card className="h-100 shadow-sm border-0 rounded-3">
      <CardBody className="d-flex align-items-center p-3">
        <div
          className="d-flex align-items-center justify-content-center bg-light-info rounded-3 me-3"
          style={{ width: 40, height: 40 }}
        >
          <TrendingUp size={20} className="text-info" />
        </div>
        <div>
          <h5 className="mb-0 fw-bold text-info">{userData.totalEarned}</h5>
          <small className="text-muted">Total Earned</small>
        </div>
      </CardBody>
    </Card>
  </Col>

  {/* Total Redeemed */}
  <Col lg={2} md={6}>
    <Card className="h-100 shadow-sm border-0 rounded-3">
      <CardBody className="d-flex align-items-center p-3">
        <div
          className="d-flex align-items-center justify-content-center bg-light-danger rounded-3 me-3"
          style={{ width: 40, height: 40 }}
        >
          <TrendingDown size={20} className="text-danger" />
        </div>
        <div>
          <h5 className="mb-0 fw-bold text-danger">{userData.totalRedeemed}</h5>
          <small className="text-muted">Total Redeemed</small>
        </div>
      </CardBody>
    </Card>
  </Col>

  {/* Total Deducted */}
  <Col lg={2} md={6}>
    <Card className="h-100 shadow-sm border-0 rounded-3">
      <CardBody className="d-flex align-items-center p-3">
        <div
          className="d-flex align-items-center justify-content-center bg-light-warning rounded-3 me-3"
          style={{ width: 40, height: 40 }}
        >
          <MinusCircle size={20} className="text-warning" />
        </div>
        <div>
          <h5 className="mb-0 fw-bold text-warning">{userData.totalDeducted}</h5>
          <small className="text-muted">Total Deducted</small>
        </div>
      </CardBody>
    </Card>
  </Col>
</Row>


                {/* Summary Stats */}
{historyData.length > 0 && (
  <Row className="mt-3">
    <Col>
      <Card className="rounded-3 shadow-sm">
        <CardBody>
          <h6 className="mb-3 fw-semibold">Quick Loyalty Stats</h6>
          <Row className="g-3">

            {/* Earn Transactions */}
            <Col md={3}>
              <div className="d-flex align-items-center p-3 rounded-3" style={{ backgroundColor: "#f8fafc" }}>
                <div className="rounded-circle d-flex align-items-center justify-content-center me-3"
                  style={{ width: 40, height: 40, backgroundColor: "#dbeafe" }}>
                  <ArrowDown size={18} className="text-success" />
                </div>
                <div>
                  <small className="text-muted d-block">Earn Transactions</small>
                  <h5 className="fw-bold text-dark mb-0">
                    {historyData.filter(h => h.type === "earn").length}
                  </h5>
                </div>
              </div>
            </Col>

            {/* Redeem Transactions */}
            <Col md={3}>
              <div className="d-flex align-items-center p-3 rounded-3" style={{ backgroundColor: "#fef2f2" }}>
                <div className="rounded-circle d-flex align-items-center justify-content-center me-3"
                  style={{ width: 40, height: 40, backgroundColor: "#fee2e2" }}>
                  <ArrowUp size={18} className="text-danger" />
                </div>
                <div>
                  <small className="text-muted d-block">Redeem Transactions</small>
                  <h5 className="fw-bold text-dark mb-0">
                    {historyData.filter(h => h.type === "redeem").length}
                  </h5>
                </div>
              </div>
            </Col>

            {/* Avg Points per Earn */}
            <Col md={3}>
              <div className="d-flex align-items-center p-3 rounded-3" style={{ backgroundColor: "#eff6ff" }}>
                <div className="rounded-circle d-flex align-items-center justify-content-center me-3"
                  style={{ width: 40, height: 40, backgroundColor: "#dbeafe" }}>
                  <Star size={18} className="text-warning" />
                </div>
                <div>
                  <small className="text-muted d-block">Avg Points / Earn</small>
                  <h5 className="fw-bold text-dark mb-0">
                    {historyData.length > 0
                      ? Math.round(userData.totalEarned / (historyData.filter(h => h.type === "earn").length || 1))
                      : 0}
                  </h5>
                </div>
              </div>
            </Col>

            {/* Last Activity */}
            <Col md={3}>
              <div className="d-flex align-items-center p-3 rounded-3" style={{ backgroundColor: "#faf5ff" }}>
                <div className="rounded-circle d-flex align-items-center justify-content-center me-3"
                  style={{ width: 40, height: 40, backgroundColor: "#ede9fe" }}>
                  <Calendar size={18} className="text-purple" />
                </div>
                <div>
                  <small className="text-muted d-block">Last Activity</small>
                  <h6 className="fw-bold text-dark mb-0">
                    {moment(historyData[0]?.date).format("DD MMM YYYY")}
                  </h6>
                </div>
              </div>
            </Col>

          </Row>
        </CardBody>
      </Card>
    </Col>
  </Row>
)}



                {/* History Table */}
                <Row>
                    <Col>
                        <Card>
                            <CardBody style={{ padding: '15px' }}>
                                <Row xxl={12} className='pb-2'>
                                    <Row>
                                        <Col md={6} lg={6} xl={6} xxl={6}>
                                            <div>
                                                <h5 className='mb-0 font-bold'>
                                                    Points History ({historyData.length} transactions)
                                                </h5>
                                            </div>
                                        </Col>
                                        <Col md={6} lg={6} xl={6} xxl={6}>
                                            <div className="file-content file-content1 gap-2 justify-content-end">
                                                {can('loyalty.update') && <Button
                                                    color="success"
                                                    size="sm"
                                                    onClick={() => {setIsOpen(true); setIsAdd(true)}}
                                                    className="d-flex align-items-center gap-1"
                                                >
                                                    <PlusCircle size={14}  />
                                                    <span>Add Points</span>
                                                </Button>}
                                                {can('loyalty.update') && <Button
                                                    color="danger"
                                                    size="sm"
                                                    onClick={() => {setIsOpen(true); setIsAdd(false)}}
                                                    className="d-flex align-items-center gap-1"
                                                >
                                                    <MinusCircle size={14}  />
                                                    <span>Deduct Points</span>
                                                </Button>}
                                            </div>
                                        </Col>
                                    </Row>
                                </Row>
                            </CardBody>

                            {historyData.length > 0 ? (
                                <DataTable
                                    data={historyData}
                                    columns={historyColumns}
                                    striped={true}
                                    center={true}
                                    pagination
                                    paginationPerPage={10}
                                    paginationRowsPerPageOptions={[5, 10, 25, 50]}
                                    noDataComponent={
                                        <div className="text-center bg-primary py-4">
                                            <Award size={48} className="text-muted  mb-3" />
                                            <h6>No loyalty history found</h6>
                                            <p className="text-muted">This user hasn't earned or redeemed any points yet.</p>
                                        </div>
                                    }
                                />
                            ) : (
                                <div className="text-center mx-auto flex flex-col items-center justify-center py-5">
                                    <Award size={48} className="text-muted mb-3" />
                                    <h6>No loyalty history found</h6>
                                    <p className="text-muted">This user hasn't earned or redeemed any points yet.</p>
                                </div>
                            )}
                        </Card>
                    </Col>
                </Row>
            </Container>
             <PointsModal onSuccess={fetchUserHistory} userId={userId} isOpen={isOpen} isAdd={isAdd} toggle={() =>{ setIsOpen(!isOpen); setIsAdd(!isAdd)}} />
        </Fragment>
    );
};

export default LoyaltyHistory;